<template>
  <div class="main">
    <!-- 蓝字发票开具 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('goInvoice')"><Back /></el-icon>
        <h2 class="bread">蓝字发票开具</h2>
      </div>
    </div>
    <div class="operate-main">
      <div class="operate-wrap">
        <div class="common-box">
          <h3 class="title">数据概览</h3>
          <div class="common-box-content">
            <div class="data-wrap">
              <div class="data-item">
                <p style="font-size: 14px; color: #333">可用授信额度</p>
                <p style="font-size: 24px; color: #fc556b; line-height: 40px">
                  <span>{{ usageStatist.remainAmount }}</span>
                  <span style="font-size: 22px">元</span>
                  <el-button type="primary" size="small" plain style="margin-left: 20px" @click="warn">可调整</el-button>
                </p>
                <p style="font-size: 16px; color: #333; margin-top: 20px">
                  总授信额度: <span>{{ usageStatist.totalCreditLimit }}元</span>
                </p>
              </div>
              <div class="data-item">
                <p style="font-size: 14px; color: #333">当前可用纸票数量（张）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">
                  0
<!--                  {{ (Number(bank.invoiceAmount) - Number(statistics.invoiceAmount)).toFixed(2) }}-->
                </p>
                <p style="font-size: 16px; color: #333; margin-top: 20px">
                  已开具：0<!--<span>{{ Number(statistics.invoiceAmount ?? 0).toFixed(2) }}</span>-->
                  张
                </p>
                <p style="font-size: 16px; color: #666; font-weight: 700">_</p>
              </div>
              <div class="data-item">
                <p style="font-size: 14px; color: #333">蓝字发票开具金额（元）</p>
                <p style="font-size: 24px; color: #333; line-height: 40px">{{ usageStatist.blueAmount }}</p>
                <p style="font-size: 16px; color: #333; margin-top: 20px">
                  累计税额：
                  <span>{{ usageStatist.blueTax }}</span>
                  元
                </p>
                <p style="font-size: 16px; color: #333; margin-top: 20px">
                  发票数量：<span>{{ usageStatist.blueCount }} </span>张
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="common-box">
          <h3 class="title">发票填开</h3>
          <div class="common-box-content">
            <div class="big_operate_btns">
              <ul>
                <li v-for="item in opearteList" :key="item.key" @click="operateBtn(item)">
                  <img :src="item.url" alt="#" style="width: 37px; object-fit: contain" />
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
            <el-divider />
            <div style="width: 100%; margin-top: 20px">
              <div class="big_kuaijie_btn" @click="warn">
                <div class="img-box">
                  <img
                    src="https://static.rhkj.com/renhe_fe/other/blueInvoice/operate6_icon.png"
                    alt="#"
                    style="width: 33px; aspect-ratio: 1; object-fit: contain"
                  />
                  <el-text type="primary" tag="p">添加快捷开票方式</el-text>
                </div>
                <p style="box-sizing: border-box; width: 100%; padding: 0 20px; line-height: 1.5; font-size: 12px; color: #999; text-align: left">
                  支持自定义发票类型、客户信息、项目信息等内容。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="common-box">
          <div class="title" style="display: inline-flex; justify-content: space-between">
            <h3>最近开票</h3>
            <span style="font-size: 12px; color: #999; cursor: pointer" @click="warn">
              查看更多 <el-icon><ArrowRight /></el-icon>
            </span>
          </div>

          <div class="common-box-content">
            <el-table :data="tableData" :border="true">
              <el-table-column label="序号" type="index" width="60" />
              <el-table-column label="发票种类" min-width="100">
                <template #default>
                  <span>电子发票</span>
                </template>
              </el-table-column>
              <el-table-column label="发票票种" prop="categoryName" min-width="180">
                <template #default="{ row }">
                  <span>{{ `增值税电子${row.categoryName || ''}` }}</span>
                </template>
              </el-table-column>
              <el-table-column label="购方名称" min-width="200">
                <template #default="{ row }">
                  <span>{{ row.buyer?.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="全电发票号码" prop="number" min-width="200" />
              <el-table-column label="发票代码" :formatter="() => '-'" min-width="100" />
              <el-table-column label="发票号码" :formatter="() => '-'" min-width="100" />
              <el-table-column label="合计金额" prop="totalAddedTaxAmount" min-width="120" />
              <el-table-column label="开票日期" prop="createTime" min-width="180" />
              <el-table-column label="操作" width="150" fixed="right">
                <template #default="{ row }">
                  <div>
                    <el-button type="primary" link @click="preview(row)">预览</el-button>
                    <el-button type="primary" link @click="warn">复制开票</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 立即开票 -->
    <el-dialog v-model="dialog.visible" title="立即开票" width="536" class="fp-dialog">
      <div class="hd">
        <ul style="width: 100%; display: inline-flex">
          <li class="active">电子发票</li>
          <li @click="warn">纸质发票</li>
        </ul>
      </div>
      <el-form :model="dialog.formData" label-position="top" style="margin-top: 20px" ref="formInvoiceRef">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择票类" prop="invoiceType" :rules="[{ required: true, message: '请选择票类', trigger: ['blur', 'change'] }]">
              <el-select v-model="dialog.formData.invoiceType" placeholder="请选择" :empty-values="['', null, undefined]" clearable @change="invoiceBusinessClear" @clear="invoiceBusinessClear">
                <el-option label="增值税专用发票" value="2" />
                <el-option label="普通发票" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特定业务" prop="invoiceBusiness">
              <el-select v-model="dialog.formData.invoiceBusiness" placeholder="请选择（非必选项）" :disabled="dialog.formData.invoiceType != 2" :empty-values="['', null, undefined]" clearable>
                <el-option label="建筑服务" value="1" />
                <el-option label="货物运输服务" value="2" />
                <el-option label="不动产经营租赁服务" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="差额征税" prop="difference">
              <el-select placeholder="请选择(非必选项)" :disabled="true" :empty-values="[null, undefined]" clearable> </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="减按征税" prop="reduce">
              <el-select placeholder="请选择(非必选项)" :disabled="true" :empty-values="[null, undefined]" clearable> </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <el-button type="default" @click="dialog.visible = false">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </template>
    </el-dialog>

    <!-- 发票预览 -->
    <invoce-dialog v-model="visible" :row="currentRow" />
  </div>
</template>

<script setup name="BlueInvoice">
import { getBlueInvoiceList, getBlueInvoiceStatistic } from '@/api/invoice';
import { ElMessageBox, ElMessage } from 'element-plus';
import invoceDialog from '../cmp/invoceDialog.vue';
import useInvoiceStore from '@/store/modules/invoice';
import {useAllInvoice} from "@/views/digitalInvoice/invoiceQueryStatist/allInvoiceSummary.js";

const useInvoice = useInvoiceStore();
const emits = defineEmits(['changePage', 'goInvoice']);

const statistics = ref({});
const bank = ref({});

const opearteList = [
  { name: '立即开票', key: 'ljkp', url: 'https://static.rhkj.com/renhe_fe/other/blueInvoice/operate1_icon.png' },
  { name: '发票草稿', key: 'fpcg', url: 'https://static.rhkj.com/renhe_fe/other/blueInvoice/operate2_icon.png' },
  { name: '扫码开票', key: 'smkp', url: 'https://static.rhkj.com/renhe_fe/other/blueInvoice/operate3_icon.png' },
  { name: '复制开票', key: 'fzkp', url: 'https://static.rhkj.com/renhe_fe/other/blueInvoice/operate4_icon.png' },
  { name: '批量开票', key: 'plkp', url: 'https://static.rhkj.com/renhe_fe/other/blueInvoice/operate5_icon.png' },
];

const dialog = reactive({
  visible: false,
  formData: {
    invoiceType: '',
    invoiceBusiness: '',
  },
});

const invoiceBusinessClear = () => {
  dialog.formData.invoiceBusiness = '';
}

const tableData = ref([]);

const {usageStatist} = useAllInvoice()

onMounted(() => {
  bank.value = useInvoice.sysSetting.bank;
  initStatic();
  initBlueInvoice();
});

function initBlueInvoice() {
  const data = useInvoice.blueInvoiceList;
  tableData.value = [...data].filter((item) => item.status == '正常发票');
}

function initStatic() {
  const data = useInvoice.getBlueInvoiceStatistic;
  statistics.value = Object.assign({}, data);
}
//点击发票填开
function operateBtn(data) {
  if (data.key == 'ljkp') {
    //点击立即开票
    dialog.visible = true;
  } else {
    warn();
  }
}

//警告功能
function warn() {
  ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}

//点击弹框
const formInvoiceRef = ref(null);
function confirm() {
  const { invoiceType, invoiceBusiness } = dialog.formData;
  formInvoiceRef.value.validate(valid => {
    if (valid) {
      sessionStorage.setItem('fapiao_type', invoiceType);
      sessionStorage.setItem('fapiao_business', invoiceBusiness);
      emits('changePage', 'blueInvoice_invoicing');
    }
  });
}

const visible = ref(false);
const currentRow = ref({});
//点击预览按钮
function preview(data) {
  currentRow.value = Object.assign({}, data);
  visible.value = true;
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      > .bread {
        margin-inline-start: 0.1rem;
        font-weight: 600;
        color: #333;
      }
    }
  }
  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    .operate-wrap {
      width: 100%;
      .common-box {
        box-sizing: border-box;
        width: inherit;
        padding: 0 20px 20px;
        border-radius: 3px;
        background-color: #fff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
        &:not(:first-child) {
          margin-block-start: 20px;
        }
        > .title {
          width: 100%;
          height: 60px;
          line-height: 60px;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #eee;
        }
        .common-box-content {
          width: 100%;
          margin-block-start: 20px;
          .data-wrap {
            display: inline-flex;
            .data-item {
              position: relative;
              width: 340px;
              &::before {
                content: '';
                display: block;
                position: absolute;
                left: -20px;
                top: 0;
                bottom: 0;
                width: 1px;
                background-color: #eee;
              }
            }
          }
          .big_operate_btns {
            width: inherit;
            > ul {
              display: flex;
              gap: 20px;
              li {
                width: 210px;
                height: 116px;
                border-radius: 3px;
                border: 1px solid rgb(238, 238, 238);
                display: flex;
                flex-flow: column wrap;
                row-gap: 20px;
                justify-content: center;
                align-items: center;
                font-size: 14px;
                color: rgb(51, 51, 51);
                cursor: pointer;
              }
            }
          }
          .big_kuaijie_btn {
            width: 210px;
            height: 180px;
            border-radius: 3px;
            border: 1px solid #eee;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            row-gap: 20px;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            user-select: none;
            .img-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              row-gap: 20px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

:deep(.fp-dialog) {
  .el-dialog__body {
    .hd {
      width: 100%;
      li {
        width: 50%;
        height: 40px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
        border: 1px solid #eee;
        line-height: 40px;
        text-align: center;
        &:first-child {
          border-radius: 3px 0 0 3px;
        }
        &:last-child {
          border-radius: 0 3px 3px 0;
        }
        &.active {
          background-color: #4285f4;
          color: #fff;
          border: 1px solid #4285f4;
        }
      }
    }
  }
}
</style>
